import { PostHogIdentify } from '@zealot/ui';
import { useAuth } from '@/pages/AuthContext';

export const PostHogIdentifyWrapper = () => {
  const { user, isAuthenticated } = useAuth();

  return <PostHogIdentify user={user} isAuthenticated={isAuthenticated} userType="fan" />;
};
